module.exports = __webpack_public_path__ + "static/img/product_images_big26_h5_zh.1f855ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_big26_h5_zh.png
// module id = TSCu
// module chunks = 34